const configNode = document.querySelector<HTMLElement>('#ents-wishlist-config');

export interface Config {
  apiEndpoint?: string;
  currentlyLoggedIn?: string;
  displayedItemCount?: string;
  messageWishlistTextActive?: string;
  messageWishlistTextInactive?: string;
  messageButtonAriaLabel?: string;
  messageBrandFollowTextActive?: string;
  messageBrandFollowTextInactive?: string;
  messageBrandFollowAriaLabel?: string;
  messageBrandFollowSnackbar?: string;
  currency?: string;
  country?: string;
  assetsHost?: string;
  homepage?: string;
}

export const config = (configNode?.dataset ?? {}) as Config;

export const ADDED_TO_WISHLIST_EVENT = 'ents:wishlist:added';
export const REMOVED_FROM_WISHLIST_EVENT = 'ents:wishlist:removed';
export const ADD_TO_WISHLIST_EVENT = 'ents:wishlist:add';
export const REMOVE_FROM_WISHLIST_EVENT = 'ents:wishlist:remove';
export const REMOVE_COUNT_FROM_WISHLIST_EVENT = 'ents:wishlist:remove:bulk:count';
export const LOGGED_OUT_EVENT = 'ents:wishlist:user-logged-out';

export const ADD_BRAND_EVENT = 'ents:brand:add';
export const REMOVE_BRAND_EVENT = 'ents:brand:remove';
export const ADDED_BRAND_EVENT = 'ents:brand:added';
export const REMOVED_BRAND_EVENT = 'ents:brand:removed';
